import buildCustomCommandServices from './customCommandServices';
import { validateName } from './customCommands.identifiers';
import { prepareParameters } from './customCommands.parameterHandling';

// CustomQRulesAction is
// CustomQRulesServices -> String | Promise[String]

const validateCommandName = validateName('command');

// (CustomQRulesAction) -> (QRulesServices) -> Promise[String]
const makeExecutor = (action) => async (services) =>
    await action(buildCustomCommandServices(services));

// (CommandDefinition, CustomQRulesAction) -> qRulesCommand
const wrapCommand = (definition, action) => ({
    optionalParameters: prepareParameters(definition),
    executeAsync: makeExecutor(action),
});

// (QRulesInstance, String, CommandDefinition?, CustomQRulesAction) -> void
const registerCustomCommand = (qRulesInstance, name, definition, action) => {
    if (typeof action !== 'function') {
        throw new Error('Command action must be a function.');
    }

    validateCommandName(name);

    const actualName = 'Custom' + name;

    qRulesInstance.addCommand(actualName, wrapCommand(definition, action));
};

export default registerCustomCommand;
